import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const FireSecurityIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.29668 15.1673C4.37141 15.1673 2 12.7795 2 9.83398C2 8.44478 2.63886 7.05561 3.47283 5.83398C3.64397 6.83398 4.38351 8.76732 5.97252 8.50065C4.22332 4.83398 7.29668 1.83398 7.29668 1.83398C7.29668 1.83398 7.62775 4.16732 10.6071 6.50065C10.883 6.7167 11.1238 6.93935 11.3333 7.16732"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3327 11.921V11.0501C13.3327 10.5581 13.3327 10.3121 13.2279 10.1516C13.1231 9.9911 12.8863 9.91318 12.4125 9.75735C12.0888 9.65088 11.8035 9.5226 11.5755 9.4055C11.2647 9.24585 11.1093 9.16602 10.9993 9.16602C10.8894 9.16602 10.734 9.24585 10.4232 9.4055C10.1952 9.5226 9.9099 9.65087 9.58621 9.75735C9.11244 9.91318 8.87555 9.9911 8.77078 10.1516C8.66602 10.3121 8.66602 10.5581 8.66602 11.0501V11.921C8.66602 13.6086 9.97859 14.6211 10.6348 15.0218C10.7922 15.118 10.8709 15.166 10.9993 15.166C11.1278 15.166 11.2065 15.118 11.3639 15.0218C12.0201 14.6211 13.3327 13.6086 13.3327 11.921Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
